import { useForm } from "@/src/provider/Form/FormProvider";
import DefenseProcessBaseData from "@/src/components/Form/AbstractLitigationCase/DefenseProcessBaseData";
import Grid from "@mui/material/Grid";
import Group from "@/src/components/Wizard/Group";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { emailDefault, isPhoneNumberDefault, requiredValidator } from "@/src/services/validationRules";
import Person from "@/src/components/Form/Common/Person/Person";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import Address from "@/src/components/Form/Common/Address/Address";
import React from "react";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { translate } from "@/src/services/translations/translations";

type DefenseProcessDataProps = {
  product: AbstractCase;
};

export default function DefenseProcessData({ product }: DefenseProcessDataProps) {
  const { values } = useForm();

  return (
    <>
      <DefenseProcessBaseData product={product} />
      {["paymentOrder", "reminder", "lawsuit"].includes(values.defenseProcessStatus) && (
        <>
          <Grid size={12}>
            <Group
              type="radio"
              name="contractualPartnerHasLawyer"
              question={translate(`${product.name}.contractualPartnerHasLawyer.question`, values)}
              options={[
                {
                  labelText: translate(`${product.name}.contractualPartnerHasLawyer.options.yes.label`, values),
                  labelIcon: <CheckIcon />,
                  labelIconActive: <CheckIcon active />,
                  value: "yes",
                },
                {
                  labelText: translate(`${product.name}.contractualPartnerHasLawyer.options.no.label`, values),
                  labelIcon: <CrossIcon />,
                  labelIconActive: <CrossIcon active />,
                  value: "no",
                },
              ]}
              validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
            />
          </Grid>
        </>
      )}
      {values.contractualPartnerHasLawyer === "yes" && (
        <>
          <Person fieldsAreRequired={false} allowNoGender={false} path="opponentLawyer" headline={translate(`${product.name}.opponentLawyer.headline`, values)} />
          <Grid size={12}>
            <ValidatorTextField
              name="opponentLawFirm.organization.name"
              label={translate("employmentContract.opponentLawFirm.organization.name.label", values)}
            />
          </Grid>
          <Address
            fieldsAreRequired={false}
            path="opponentLawFirm.organization.address"
            headline={translate(`${product.name}.opponentLawFirm.organization.address.headline`, values)}
          />
          <Grid size={12}>
            <ValidatorTextField
              name="opponentLawFirm.organization.mainEmail.email"
              label={translate(`${product.name}.opponentLawFirm.organization.mainEmail.email.label`, values)}
              validators={[emailDefault]}
            />
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              name="opponentLawFirm.organization.telephone"
              label={translate(`${product.name}.opponentLawFirm.organization.telephone.label`, values)}
              validators={isPhoneNumberDefault}
            />
          </Grid>
        </>
      )}
    </>
  );
}
